export default __webpack_public_path__ + "static/media/faci16.de2d7780.jpg";